import { CountUp } from "countup.js";
import Swiper from "swiper";
import { A11y, Autoplay, Pagination } from "swiper/modules";
import "./stats.css";
import "@/styles/components/slider.css";

const runCounter = (el) => {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    return;
  }

  const useGrouping = el.dataset.useGrouping;
  const decimalPlaces = el.dataset.decimalPlaces;
  const end = el.dataset.end;

  const opts = {
    useGrouping: !!+useGrouping,
  };

  if (decimalPlaces) {
    opts.decimalPlaces = decimalPlaces;
  }

  const counter = new CountUp(el, end, opts);

  counter.start();
};

document.querySelectorAll(".element-stats").forEach((el) => {
  const container = el.querySelector(".swiper");
  const numSlides = el.querySelectorAll(".swiper-slide").length;

  if (numSlides > 1) {
    const swiper = new Swiper(container, {
      modules: [A11y, Autoplay, Pagination],
      autoplay: {
        delay: 3000,
      },
      speed: 750,
      loop: true,
      pagination: {
        el: el.querySelector(".slider-pagination"),
        clickable: true,
      },
      slidesPerView: 1,
      spaceBetween: 24,
      watchSlidesProgress: true,
      centerInsufficientSlides: true,
      breakpoints: {
        640: {
          enabled: numSlides > 3,
          slidesPerView: 3,
          loop: numSlides > 3,
        },
        1024: {
          enabled: numSlides > 4,
          slidesPerView: 4,
          loop: numSlides > 4,
        },
        1280: {
          enabled: numSlides > 4,
          slidesPerView: 4,
          loop: numSlides > 4,
          spaceBetween: 32,
        },
      },
    });

    swiper.autoplay.stop();

    const handleActiveSlide = (activeSlide) => {
      if (!activeSlide.classList.contains("did-run")) {
        const counters = activeSlide.querySelectorAll("[data-counter]");
        counters.forEach((counter) => runCounter(counter));

        activeSlide.classList.add("did-run");
      }
    };

    swiper.on("autoplayStart", () => {
      if (swiper.enabled) {
        const activeSlide = swiper.slides[swiper.activeIndex];
        handleActiveSlide(activeSlide);
      } else {
        el.querySelectorAll(".swiper-slide").forEach((slide) => {
          handleActiveSlide(slide);
        });
      }
    });

    swiper.on("slideChange", () => {
      const activeSlide = swiper.slides[swiper.activeIndex];
      handleActiveSlide(activeSlide);
    });

    const observer = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          swiper.autoplay.start();
          observer.disconnect();
        }
      },
      {
        threshold: [0.7],
      },
    );

    observer.observe(el);
  }
});
